<style>
    #scrollableTable {
         overflow-y: scroll;
       }
     @media screen and (min-width: 500px) {
   
     }
   </style>

<div class="container">


        <h2 class="content-heading"> 
              Propers
        </h2>

        <div *ngIf="isLoading != true">
        <div *ngIf="data != null && data.length > 0">
          <div class=row>
  
              <div class="col-sm-5">
   
                Show
                <select (change)="changeNumberOfRecords()" [(ngModel)]="numberOfRecords">
                  <option value=15>15</option>
                    <option value=30>30</option>
                    <option value=60>60</option>
                    <option value=99999>All</option>
                </select>
                entries  
  
            </div>
          
            <div class="col-sm-7 text-right"> 
              <span style="margin-right:20px">
                Proofed: 
                <select  (change)="changeProofedOption()" [(ngModel)]="searchProofed">
                  <option [ngValue]=null></option>
                  <option  [ngValue]=true>Yes</option>
                  <option  [ngValue]=false>No</option>
                </select>
              </span> 
            </div>
            
          </div>
   

            <div class="table-responsive table yearDataTable">
 
                <div class="xrow header gridRow row">
                    <div class="col-md-4">Proper Number</div>
                    <div class="col-md-3">Weekday</div>
                    <div class="col-md-3">Proofed</div>
                    <div class="col-md-2 text-right">Actions</div>
                </div>
 
                <div id="scrollableTable">
                      
                  <div *ngFor="let obj of data | properFilter: searchProofed | paginate: { itemsPerPage: numberOfRecords, currentPage: pageNumber }" class="dateRow gridRow row">
                    <div class="col-md-4">{{obj.ProperNumber}}</div>
                    <div class="col-md-3">{{obj.Weekday}} </div> 
                    <div class="col-md-3">{{obj.ProofedByName}} </div> 
                    <div class="col-md-2 text-right">
                        <div class="btn-group">
                            <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                                <i class="fa fa-pencil"></i>
                            </button> 
                        </div>
                    </div>
                  </div>

                </div>


              </div>


 <div id="pageButtons" style="overflow: auto">
 
  {{ renderPaginationItemStatus(p) }} of {{ p.getTotalItems()}} entries
 
  <pagination-template #p="paginationApi" (pageChange)="pageNumber = $event" class="float-right">
   
    <div class="custom-pagination">
  
      <ul class="pagination pagination">
    
        <li class="page-item">
          <a class="page-link" *ngIf="!p.isFirstPage()" (click)="p.previous();">
            <i class="fa fa-angle-double-left"></i>
          </a>
        </li>
  
        <li class="page-item" *ngFor="let page of p.pages" [class.active]="p.getCurrent() === page.value">
          <a class="page-link" (click)="p.setCurrent(page.value);" *ngIf="p.getCurrent() !== page.value">
            <span>{{ page.label }}</span>
          </a>
          <a class="page-link" *ngIf="p.getCurrent() === page.value">
            <span>{{ page.label }}</span>
          </a>
        </li>
  
        <li class="page-item">
          <a class="page-link"  *ngIf="!p.isLastPage()" (click)="p.next();">
              <i class="fa fa-angle-double-right"></i>
          </a>
        </li>
 

     
  
      </ul> 
  
    </div>
  
  </pagination-template>

  </div>
  
  <div>
 
    <div>
      Total Proofed: 
      {{countTotalProofed}}
    </div>
    <div>
      Total Not Proofed:
      {{countTotalNotProofed}}
    </div>
    
</div>

      </div>
    </div>


      <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>

